import { PayloadAction } from '@reduxjs/toolkit';
import { SyfoAppState } from '../state';
import { ProtectionNode } from '@syfo/types/vault.types';
import { updateById } from './reducer-utils';

export const addProtection = (state: SyfoAppState, action: PayloadAction<ProtectionNode>) => {
  if (state.currentVault) {
    state.currentVault.data.protection.push(action.payload);
  }
};

export const updateProtection = (state: SyfoAppState, action: PayloadAction<{ id: string; protection: Partial<ProtectionNode> }>) => {
  if (state.currentVault) {
    updateById(state.currentVault.data.protection, action.payload.id, action.payload.protection);
  }
};

export const removeProtection = (state: SyfoAppState, action: PayloadAction<string>) => {
  if (state.currentVault) {
    state.currentVault.data.protection = state.currentVault.data.protection.filter(p => p.id !== action.payload);
  }
};